import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Scene-count badges for the shell's top bar and dock header. */
import { useHierarchy } from '../../contexts/HierarchyContext.js';
import { useLiveSceneNodes } from '../../useLiveSceneTree.js';
import { isCamera3DType } from '../../cameraNodeTypes.js';
import styles from './TscnPreviewShell.module.css';
/** A stable predicate, so the memo of `useLiveSceneNodes` does not recompute each render. */
const isCamera3D = (n) => isCamera3DType(n.type);
/**
 * Each chip's text is one node, such as "4 nodes", so it never matches a tree
 * row's `findByText`. The node count is authored, an instance counting once as
 * in Godot's scene dock. The camera count reads the live scene tree.
 */
export function SceneStats() {
    const { sceneGraph } = useHierarchy();
    const cameras = useLiveSceneNodes(isCamera3D);
    if (sceneGraph === null)
        return null;
    const nodeCount = sceneGraph.flattenedNodes.length;
    const cameraCount = cameras.length;
    return (_jsxs("div", { className: styles.statChips, role: "group", "aria-label": "Scene info", children: [_jsx("span", { className: styles.statChip, "data-testid": "scene-info-nodes", children: `${nodeCount} nodes` }), cameraCount > 0 && (_jsx("span", { className: styles.statChip, children: `${cameraCount} ${cameraCount === 1 ? 'camera' : 'cameras'}` }))] }));
}
/** Node-count badge for the Scene Tree dock header. */
export function SceneNodeCount() {
    const { sceneGraph } = useHierarchy();
    if (sceneGraph === null)
        return null;
    return _jsxs("span", { className: styles.dockCount, children: [sceneGraph.flattenedNodes.length, " nodes"] });
}
//# sourceMappingURL=SceneStats.js.map